import React from 'react';
import { KBBlock } from '../../../types';

interface Props {
  block: KBBlock;
  isEditing: boolean;
  onChange: (updates: Partial<KBBlock>) => void;
  onFinish: () => void;
}

const DividerBlock: React.FC<Props> = ({ isEditing, onFinish }) => {
  if (isEditing) {
    return (
      <div className="space-y-2">
        <hr className="border-t-2 border-gray-300" />
        <button onClick={onFinish} className="text-xs text-gray-400 hover:text-gray-600">Done</button>
      </div>
    );
  }
  return <hr className="border-t-2 border-gray-200 my-1" />;
};

export default DividerBlock;
